import { grey, red, pink,blueGrey, lightBlue, deepOrange, orange, lightGreen} from '@material-ui/core/colors';
import { createTheme,  } from '@material-ui/core/styles';
import {responsiveFont}  from './themeTypography';

// A custom theme for this app
const colorTextPrimary      = grey[800]; 
const colorSecondaryPrimary = grey[700]; 

/*https://m2.material.io/design/color/the-color-system.html#tools-for-picking-colors */

let theme = createTheme({
  palette: {
    primary: {
      main: '#fff', 
      contrastText: colorTextPrimary
    },

    secondary: {
      main: blueGrey[800],
      contrastText: '#fff',
    },

    accent:{
      main: '#98c545', // '#4caf50',
      contrastText: '#fff',
    }, 

    alert:{
      main: pink.A200, // '#4caf50',
      contrastText: '#fff',
    }, 

    error: {
      main: red.A400,
      background: red.A200, 
    },
   
    text: { 
      main: colorTextPrimary,
      primary:  colorTextPrimary ,
      secondary:colorSecondaryPrimary, //grey[700],
      muted: grey[600],
      disable: grey[300],
    },

    background: {
      grey60   : grey[50],
      grey   : grey[100],
      default: '#fff',
      whatsapp:  blueGrey[800],//'#6add75' //green[400],
      warnning: deepOrange[100],
      info: lightBlue[100],
      pink: pink[50], 
      orange: orange[50], 
      lightGreen: lightGreen[50],
      lightBlue: lightBlue[50]
    },

    icon:{
      main: grey[600],
    },
  },

  status: {
    danger:  '#4caf50',  //'#FFFFFF',
  },

  paths:{
    home:  "/webapp",
    store: "/store",
    local: "/local",
    qr:    "/qr",
    ticket:"/ticket"
  }, 

  boxShadow:{
     //box-shadow: [horizontal offset] [vertical offset] [blur radius] [optional spread radius] [color];
    image: '0 2px 2px 0px rgb(0 0 0 / 0.6)',
    up: '0 3px 3px 0px rgb(0 0 0 / 0.5)',
  },


});


theme = responsiveFont(theme);
export default theme;
